__turbopack_context__.v({
  "puller": "SwipeableModal-module-scss-module__ZGnyRW__puller",
  "swipeableContainer": "SwipeableModal-module-scss-module__ZGnyRW__swipeableContainer",
});
